import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { EditOutlined, DeleteOutlined, DragOutlined } from '@ant-design/icons'
var placeholderFields = require('./placeholderFields')

export default class PlaceholderOverlay extends React.PureComponent {

  static propTypes = {
    placeholder: PropTypes.object.isRequired,
    scale: PropTypes.number.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onMove: PropTypes.func.isRequired,
    onResize: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      dragging: false,
      resizing: false,
      dragStartX: 0,
      dragStartY: 0,
      origX: 0,
      origY: 0,
      origW: 0,
      origH: 0,
    }
    this.overlayRef = React.createRef()
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  }

  handleDragStart = (e) => {
    e.preventDefault()
    e.stopPropagation()
    var ph = this.props.placeholder
    this.setState({
      dragging: true,
      resizing: false,
      dragStartX: e.clientX,
      dragStartY: e.clientY,
      origX: ph.x,
      origY: ph.y,
    })
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
    if (this.props.onSelect) {
      this.props.onSelect(ph.id)
    }
  }

  handleResizeStart = (e) => {
    e.preventDefault()
    e.stopPropagation()
    var ph = this.props.placeholder
    this.setState({
      resizing: true,
      dragging: false,
      dragStartX: e.clientX,
      dragStartY: e.clientY,
      origW: ph.width,
      origH: ph.height,
    })
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseMove = (e) => {
    var scale = this.props.scale
    if (this.state.dragging) {
      var dx = (e.clientX - this.state.dragStartX) / scale
      var dy = (e.clientY - this.state.dragStartY) / scale
      this.props.onMove(this.props.placeholder.id, {
        x: Math.max(0, Math.round(this.state.origX + dx)),
        y: Math.max(0, Math.round(this.state.origY + dy)),
      })
    } else if (this.state.resizing) {
      var dw = (e.clientX - this.state.dragStartX) / scale
      var dh = (e.clientY - this.state.dragStartY) / scale
      this.props.onResize(this.props.placeholder.id, {
        width: Math.max(5, Math.round(this.state.origW + dw)),
        height: Math.max(3, Math.round(this.state.origH + dh)),
      })
    }
  }

  handleMouseUp = () => {
    this.setState({ dragging: false, resizing: false })
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  }

  handleClick = (e) => {
    e.stopPropagation()
    if (this.props.onSelect) {
      this.props.onSelect(this.props.placeholder.id)
    }
  }

  render() {
    var ph = this.props.placeholder
    var scale = this.props.scale
    var selected = this.props.selected

    var fieldDef = placeholderFields.getFieldDefinition(ph.field)
    var label = fieldDef ? fieldDef.label : ph.field
    var isImage = ph.type === 'image'

    var bgColor = isImage ? 'rgba(255, 140, 0, 0.15)' : 'rgba(0, 100, 255, 0.15)'
    var borderColor = selected ? '#1890ff' : (isImage ? '#ff8c00' : '#0064ff')

    var style = {
      position: 'absolute',
      left: ph.x * scale,
      top: ph.y * scale,
      width: ph.width * scale,
      height: ph.height * scale,
      backgroundColor: bgColor,
      border: '1px ' + (selected ? 'solid' : 'dashed') + ' ' + borderColor,
      cursor: 'move',
      zIndex: selected ? 10 : 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: Math.max(9, Math.min(11, ph.width * scale * 0.12)),
      color: borderColor,
      fontWeight: selected ? 'bold' : 'normal',
      userSelect: 'none',
      boxSizing: 'border-box',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }

    var resizeHandleStyle = {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: 8,
      height: 8,
      backgroundColor: borderColor,
      cursor: 'se-resize',
      zIndex: 11,
    }

    var actionsStyle = {
      position: 'absolute',
      top: -20,
      right: 0,
      display: selected ? 'flex' : 'none',
      gap: 4,
      zIndex: 12,
    }

    var actionBtnStyle = {
      background: '#fff',
      border: '1px solid #d9d9d9',
      borderRadius: 2,
      padding: '1px 4px',
      cursor: 'pointer',
      fontSize: 11,
      lineHeight: '16px',
    }

    return (
      <div
        ref={this.overlayRef}
        style={style}
        onMouseDown={this.handleDragStart}
        onClick={this.handleClick}
      >
        <span style={{ pointerEvents: 'none', padding: '0 2px' }}>
          {isImage ? '[' + label + ']' : '{{' + label + '}}'}
        </span>

        <div style={actionsStyle}>
          <Tooltip title="Edit">
            <span
              style={actionBtnStyle}
              onClick={function(e) { e.stopPropagation(); this.props.onEdit(ph.id) }.bind(this)}
            >
              <EditOutlined />
            </span>
          </Tooltip>
          <Tooltip title="Delete">
            <span
              style={Object.assign({}, actionBtnStyle, { color: '#ff4d4f' })}
              onClick={function(e) { e.stopPropagation(); this.props.onDelete(ph.id) }.bind(this)}
            >
              <DeleteOutlined />
            </span>
          </Tooltip>
        </div>

        <div style={resizeHandleStyle} onMouseDown={this.handleResizeStart} />
      </div>
    )
  }
}
